import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {
  
  transform(results: any[], searchFor: string): any {
    //console.log("SearchFor in filter: " + searchFor);
    return results.filter( (result) => {
      if (searchFor.includes("$")) {
        return result
      }
      
      const resultName: string = result.name.toLowerCase().substring(0, searchFor.length);
      //console.log("resultName: " + resultName);
      if (resultName.indexOf(searchFor.toLowerCase()) !== -1) {
        return result
      }
    } );  
  }
}